import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/page";

export const Route = createFileRoute("/clients/$clientId/dashboard/dearest/")({
  component: Page,
});
